<template>
  <div class="card-header border-bottom pt-1 pb-1">
    <h4 class="card-title">Education</h4>
    <div>
      <button @click="addMore" type="button" class="btn btn-primary me-1">+ Add new</button>
    </div>
  </div>

  <div class="card-body mt-2">
    <form class="invoice-repeater" @submit.prevent="$emit('storeContact', {'items':educations})">
    <div class="row d-flex align-items-end">

      <div v-for="(education, index) in educations" :key="index" class="col-md-5 col-5 card_body box_shadow">
        <div class="row d-flex align-items-end">

          <div class="col-12 org_icon_col">
            <div v-if="educations.length > 1" @click="remove(index)" class="org_dlt_icon">
              <button class="btn btn-outline-danger text-nowrap px-1 button_icon" type="button">
                <i class="fa fa-trash"></i>
              </button>
            </div>
          </div>

          <div class="col-md-12 col-12">
            <div class="mb-1">
              <input v-model="education.education" type="text" class="form-control" id="institute"
                placeholder="School/university name. Ex: Dhaka University" />
            </div>
          </div>
          <div class="col-md-12 col-12">
            <div class="mb-1">
              <input v-model="education.degree" type="text" class="form-control" id="degree"
                placeholder="Degree. Ex: BSC in Computer Science" />
            </div>
          </div>
          <div class="col-md-12 col-12">
            <div class="mb-1">
              <input v-model="education.duration" type="text" class="form-control" id="duration"
                     placeholder="Duration" />
            </div>
          </div>
          <div class="col-md-12 col-12">
            <div class="mb-1">
              <input v-model="education.passing_year" type="text" class="form-control" id="passingYear"
                     placeholder="Passing Year" />
            </div>
          </div>

          <div class="col-md-12 col-12">
            <div class="row mb-1">

              <div class="col-md-6 col-12">
                <label class="form-label">Start Date</label>
                <input v-model="education.start_date" type="date" class="form-control" />
              </div>

              <div class="col-md-6 col-12">
                <label class="form-label">End Date</label>
                <input v-model="education.end_date" type="date" class="form-control"/>
              </div>

            </div>
          </div>

        </div>
      </div>

    </div>

    <div class="row mt-5 d-flex align-items-end">
      <div class="col-sm-4 offset-4">
        <button type="submit" class="btn btn-primary me-1">Submit</button>
        <button @click="reset" type="reset" class="btn btn-outline-secondary">Reset</button>
      </div>
    </div>
    </form>
  </div>
</template>

<script setup>
import {defineProps, ref, watch} from "vue";
const props = defineProps({
  items: {
    type: Array
  }
})

const educations = ref([
  {
    education: '',
    degree: '',
    duration: '',
    passing_year: '',
    start_date: null,
    end_date: null
  }
])

const addMore = () => {
  educations.value.push({
    education: '',
    degree: '',
    duration: '',
    passing_year: '',
    start_date: null,
    end_date: null
  })
}

const remove = index => {
  educations.value.splice(index, 1)
}

const reset = () => {
  educations.value.length = 0;
  addMore();
}

watch(() => props.items, (newFormData) => {
  formDataSet();
});

const formDataSet = () => {
  if (props.items.length) {
    educations.value = props.items
  }
}
</script>

<style scoped></style>
